<script setup>
import { inject } from 'vue';

const dataView = inject('dataView');
</script>

<template>
    <app-pill-group v-if="dataView.props.views.length > 1">
        <app-pill
            :data-active="view.key === dataView.activeView.key"
            v-for="view in dataView.props.views"
            @click="dataView.renderView(view.key)">
            {{ view.label }}
        </app-pill>
    </app-pill-group>
</template>
